import { createFileRoute } from '@tanstack/react-router';
import { CasinoEmbedPage } from '../features/games/CasinoEmbedPage.js';

// Deep-linkable casino game: /casino/<gameCode> launches that game in-page.
export const Route = createFileRoute('/_player/casino/$code')({
  component: CasinoGameRoute,
});

function CasinoGameRoute() {
  const { code } = Route.useParams();
  return <CasinoEmbedPage code={code} />;
}
